import { render, staticRenderFns } from "./StudentPiiTooltip.vue?vue&type=template&id=1781a6b3"
import script from "./StudentPiiTooltip.vue?vue&type=script&lang=js"
export * from "./StudentPiiTooltip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports